import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import { useState } from 'react';

function App() {
  const [respons, setRespons] = useState(null)
  const [prompt, setPrompt] = useState('')
  const [resText,setResText] = useState('')

  const getResponse = async (promt) => {
    await axios({
      method: "POST",
      url: `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent`,
      headers: {
        "Content-Type": "application/json",
        "X-goog-api-key": "AIzaSyA-FoinQljLJq9fc49niCGTsjPj2t-IYAI"
      },
      data: {
        contents: [
          {
            parts: [
              {
                text: prompt
              }
            ]
          }
        ]
      }
    }).then(res => {
      setRespons(res)
      setResText(res.data.candidates[0].content.parts[0].text)
    })
  }

  const handleSubmit = () => {
    getResponse(prompt)
  }
  
  return (
    <div className="App" style={{ marginTop: '10%' }}>
      <div style={{marginBottom:'10px'}}>~HS AI.~</div>
      <small>Silahkan tanyakan sesuatu.</small>
      <div>
        <input
          type='text'
          style={{
            marginBottom:'20px',
            width:'450px'
          }}
          onChange={(e) => setPrompt(e.target.value)}
        />
        <button onClick={handleSubmit}>Submit</button>
      </div>
      <div>
        <textarea style={{width:'50%', height:'400px'}} value={resText}/>
      </div>
    </div>
  );
}

export default App;
